module.exports = __webpack_public_path__ + "img/tools_legislation3.073ab058.png";